const _ = require("lodash");
const {findArguments} = require("../util/ParserHelpers");

const ImageCache = require("../../util/ImageCache");

const unmaskButtonParser = function(ps) {
	const reqArgs = findArguments(ps, 1);
	if (!reqArgs) {
		ps.pushError("unmaskButton requires text");
		return false;
	}

	const buttonText = reqArgs[0].text;

	return {
		type: "unmaskButton",
		children: [
			{
				type: "color",
				children: [
					{
						type: "text",
						text: _.toUpper(buttonText) + "!",
					},
				],
				colorName: "white",
			},
		],
	};
};

const unmaskButtonNode = {
	draw(rc, x, y, node, measure) {
		const context = rc.context;
		const {width, top, bottom, childrenMeasures, fontInfo} = measure;
		const imageSrc = ImageCache.src(
			global.BASE_URL + "assets/images/problem-art/unmask-button.svg"
		);
		context.save();
		context.drawImage(imageSrc, x, y - top, width, top + bottom);
		context.restore();
		const {children = []} = node;
		children.forEach((child, i) => {
			const m = childrenMeasures[i];
			const offsetX = (node.offsetX || 0) * fontInfo.size;
			const offsetY = (node.offsetY || 0) * fontInfo.size;
			rc.drawNode(
				rc,
				x + 0.5 * width - 0.5 * m.width + offsetX || 0,
				y + offsetY || 0,
				child,
				m
			);
		});
	},

	measure(rc, fontInfo, props, node) {
		// From button dimensions
		const aspectRatio = 190 / 63;
		const width = fontInfo.size * 7.5;
		const height = width / aspectRatio;
		const children = node.children || [];
		const childrenMeasures = children.map(n =>
			rc.measureNode(rc, fontInfo, props, n)
		);
		return {
			width,
			top: height / 2,
			bottom: height / 2,
			fontInfo,
			childrenMeasures,
		};
	},

	readAloud: {children: true},
};

module.exports = {
	parsers: {
		mathCommands: {
			unmaskButton: unmaskButtonParser,
		},
	},
	nodes: {
		unmaskButton: unmaskButtonNode,
	},
};
